export default "__VITE_ASSET__CchrJdMe__"